import React from "react";
import { Container, Row, Col } from "reactstrap";

function PBX() {
  return (
    <Container id="PBX">
      <Row className="d-flex align-items-center">
      <Col xs="12" md="6">
          <div className="text-center">
            <img
              src="https://static.thenounproject.com/png/2860816-200.png"
              alt="website design Link"
              style={{ height: "auto" }}
              width={"300px"}
              height={"300px"}
            />
          </div>
        </Col>
        <Col xs="12" md="6">
          <div>
            <h1 style={{ fontWeight: "bold" }} className="hero-text">
              Software Based PBX system
            </h1>
            <p className="hero-text" style={{ fontWeight: "300" }}>
              Our expertise ensures tailored design and implementation of
              software-based PBX systems.
            </p>
          </div>
        </Col>
       
      </Row>
    </Container>
  );
}

export default PBX;
